import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import { getRoutes } from '@/http/home'

Vue.use(VueRouter)
const Home = () => import("@/views/home/index.vue");
const YLJR = () => import("@/views/yljr/index.vue");
const JZXJ = () => import("@/views/jzxj/index.vue");
const ZHXYW = () => import("@/views/zhxyw/index.vue");
const ZFBZ = () => import("@/views/zfbz/index.vue");
const YSZJ = () => import("@/views/yszj/index.vue");
const WXZJ = () => import("@/views/wxzj/index.vue");
const CLFZJ = () => import("@/views/clfzj/index.vue");
const ZFJR = () => import("@/views/zfjr/index.vue");
const routes = [
  {
    path: getPath('/home'), // 国资
    name: 'home',
    component: Home,
    meta: {
      metaInfo: {
        title: "智慧国资平台_智慧国有资产管理系统 - 湖南华信软件",
        keywords: "智慧国资系统,国资管理系统,国有资产管理系统,国有资产管理软件,国有资产管理",
        description: "湖南华信软件智慧国资管理系统包含智慧仓库,智慧商店,智慧管理三大模块,以构建全方位、全覆盖、全流程的“三资”管理运作体系,助力政企单位盘活资源,盘活资产,盘活资金,高效管理资产."
      },
    },

  },
  {
    path: getPath('/yljr'),
    name: 'yljr',
    component: YLJR,
    meta: {
      metaInfo: {
        title: "养老金融生态平台_养老金融管理系统软件开发-湖南华信软件",
        keywords: "养老金融生态平台,养老金融系统,养老金融平台,养老金融,养老金融创新",
        description: "湖南华信软件养老金融生态平台,包含养老理财、健康医疗、敬老商城、旅游出行、养老机构、家政服务、爱晚学堂等功能,助银行实现养老金融业务创新."
      },
    },
  },
  {
    path: getPath('/jzxj'),
    name: 'jzxj',
    component: JZXJ,
    meta: {
      metaInfo: {
        title: "高校奖助学金管理平台_奖助学金小程序系统开发-湖南华信软件",
        keywords: "奖助学金系统,奖助学金管理平台,助学金管理系统,学生奖助学金系统,高校奖助学金管理系统",
        description: "湖南华信软件高校奖助学金管理系统,运用信息化技术为,实现奖助学金精准评选和发放的流程化、标准化和信息化;推动困难学生精准认定和管理科学决策;拓展服务内容,提升服务质量;提升工作者的管理水平和工作效率."
      },
    },
  },
  {
    path: getPath('/zhxyw'),
    name: 'zhxyw',
    component: ZHXYW,
    meta: {
      metaInfo: {
        title: "校友会信息管理系统_校友APP小程序系统开发 - 湖南华信软件",
        keywords: "校友会管理系统,校友APP,校友小程序,校友信息系统,智慧校友平台,校友会系统",
        description: "湖南华信软件新一代智慧校友管理系统平台,建设内容为一库三屏六平台,包括:校友服务平台、综合管理平台、移动服务平台、决策分析平台、应用支撑平台、线下运营平台.助力学校信息化建设,打造校友生态圈."
      },
    },
  },
  {
    path: getPath('/zfbz'),
    name: 'zfbz',
    component: ZFBZ,
    meta: {
      metaInfo: {
        title: "保障性住房管理平台_住房保障信息管理系统 - 湖南华信软件",
        keywords: "保障房管理系统,保障性住房系统,住房保障管理平台,住房保障管理系统,保障房系统",
        description: "湖南华信软件保障性住房系统平台,主要子系统包括住房保障大数据资源中心、基础信息管理子系统、报修管理子系统、物联网综合管控子系统、动态预警及监控子系统等内容信息化建设,可提高工作效率,增强公众服务能力."
      },
    },
  },
  {
    path: getPath('/yszj'),
    name: 'yszj',
    component: YSZJ,
    meta: {
      metaInfo: {
        title: "商品房预售资金监管系统_新建商品房预售资金管理平台 - 湖南华信软件",
        keywords: "预售资金监管系统,商品房预售资金监管系统,商品房预售资金监管平台,商品房预售资金监管系统软件,预售资金管理系统",
        description: "湖南华信软件预售资金监管系统通过统一清算账户归集模式,实现一码通缴、多渠道缴存、线上大额缴存、一网(网点)通办等功能,可以很好的保障商品房预售资金的合理规范使用,进而保障每个购房者的权益."
      },
    },
  },
  {
    path: getPath('/wxzj'),
    name: 'wxzj',
    component: WXZJ,
    meta: {
      metaInfo: {
        title: "住宅专项维修资金管理系统_物业维修资金管理平台 -湖南华信软件",
        keywords: "维修资金系统,住房维修资金系统,维修资金管理系统,住宅专项维修资金管理系统,物业维修资金管理系统",
        description: "湖南华信软件住房维修资金管理系统通过监管专户管理模式,实现一码通缴、多渠道缴存、线上大额缴存、一网（网点）通办等功能,可以从各方面保障住宅专项维修资金被规范使用."
      },
    },
  },
  {
    path: getPath('/clfzj'),
    name: 'clfzj',
    component: CLFZJ,
    meta: {
      metaInfo: {
        title: "二手房交易资金监管系统_存量房交易资金监管平台 - 湖南华信软件",
        keywords: "二手房交易资金监管系统,存量房交易资金监管平台,存量房资金监管系统,二手房资金监管系统",
        description: "湖南华信软件二手存量房资金监管系统,通过监管银行管理、账户管理、资金缴存管理、资金划转/退回管理、资金监管动态分析、动态预警及监控子系统等功能,保障存量房交易资金合理规范使用、交易透明安全、钱证两清."
      },
    },
  },
  {
    path: getPath('/zfjr'),
    name: 'zfjr',
    component: ZFJR,
    meta: {
      metaInfo: {
        title: "住房金融生态平台|住房金融系统APP小程序软件开发-湖南华信软件",
        keywords: "住房金融生态平台,住房金融系统,存房消费贷平台,住房金融,住房金融创新",
        description: "湖南华信软件住房金融生态平台,助力银行获客、活客、留客、增存、增贷,首创'存房'模式,盘活二手房市场,助力银行实现住房金融业务创新."
      },
    },
  },
  {
    path: '/news',
    name: 'news',
    component: () => import("@/views/news/news.vue"),
  },
]
function getPath(path) {
  if (process.env.NODE_ENV === 'development') return path;
  const url = location.href;
  if (url.indexOf('zhgz') !== -1 && path === '/home') {
    return "/"
  } else if (url.indexOf('yljr') !== -1 && path === '/yljr') {
    return "/"
  } else if (url.indexOf('jzxj') !== -1 && path === '/jzxj') {
    return "/"
  } else if (url.indexOf('xyh') !== -1 && path === '/zhxyw') {
    return "/"
  } else if (url.indexOf('zfbz') !== -1 && path === '/zfbz') {
    return "/"
  } else if (url.indexOf('yszjjg') !== -1 && path === '/yszj') {
    return "/"
  } else if (url.indexOf('wxzj') !== -1 && path === '/wxzj') {
    return "/"
  } else if (url.indexOf('esfzjjg') !== -1 && path === '/clfzj') {
    return "/"
  }  else if (url.indexOf('zfjr') !== -1 && path === '/zfjr') {
    return "/"
  }else {
    return path;
  }
}

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

const router = new VueRouter({
  mode: process.env.NODE_ENV === 'development' ? 'hash' : 'history',
  //mode: 'hash',
  //base: '/dist/',
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  console.log(location.href, "to");
  if (to.meta.metaInfo) {
    store.dispatch('global/changeSetting', { key: 'metaInfo', value: to.meta.metaInfo })
  }
  next()
});


const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
console.log(routes, "routes");
export default router
